import React from "react";

const DropdownArrow = (props) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="current" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.4608 6.13013C11.3716 6.04681 11.2508 6 11.1247 6C10.9987 6 10.8778 6.04681 10.7886 6.13013L7.79711 8.92715L4.80559 6.13013C4.71594 6.04917 4.59586 6.00437 4.47122 6.00538C4.34658 6.0064 4.22735 6.05314 4.13921 6.13555C4.05107 6.21795 4.00108 6.32943 3.99999 6.44597C3.99891 6.56251 4.04682 6.67478 4.13342 6.75861L7.46102 9.86987C7.55016 9.95319 7.67105 10 7.79711 10C7.92316 10 8.04405 9.95319 8.13319 9.86987L11.4608 6.75861C11.5499 6.67526 11.6 6.56223 11.6 6.44437C11.6 6.32651 11.5499 6.21348 11.4608 6.13013Z" />
  </svg>
);

export default DropdownArrow;
